module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码",
      "prop": "oldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.ruleForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "oldPassword", $$v)
      },
      expression: "ruleForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "newPassword", $$v)
      },
      expression: "ruleForm.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "再输一次新密码",
      "prop": "checkNewPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm.checkNewPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkNewPassword", $$v)
      },
      expression: "ruleForm.checkNewPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "centerbtn tc"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.passwordDialogCancel()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-42cafed0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/ModifyPassword.vue
// module id = 1147
// module chunks = 41